import React from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect, useDispatch } from 'react-redux'
import {
  EditOutlined,
  SettingOutlined,
  ShopOutlined,
  QuestionCircleOutlined,
  LogoutOutlined
} from '@ant-design/icons';
// import Icon from 'components/util-components/Icon';
import { signOut } from 'redux/actions/Auth';
import { getfull_name } from "auth/LocalStorage";

const menuItem = [
  {
    title: "Edit Profile",
    icon: EditOutlined,
    path: "/"
  },

  {
    title: "Account Setting",
    icon: SettingOutlined,
    path: "/"
  },
  {
    title: "Billing",
    icon: ShopOutlined,
    path: "/"
  },
  {
    title: "Help Center",
    icon: QuestionCircleOutlined,
    path: "/"
  }
]

// {menuItem.map((el, i) => {
//   return (
//     <Menu.Item key={i}>
//       <a href={el.path}>
//         <Icon className="mr-3" type={el.icon} />
//         <span className="font-weight-normal">{el.title}</span>
//       </a>
//     </Menu.Item>
//   );
// })}



export const NavProfile = () => {
  const dispatch = useDispatch();

  const signOutFn = async () => {
    console.log("SignnOut");
    await dispatch(signOut())
  }
  const profileImg = "/img/KVVES_Logo_New.png";
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45} src={profileImg} />
          <div className="pl-3">
            <h4 className="mb-0">Unit</h4>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>

          <Menu.Item key={menuItem.length + 1} onClick={e => signOutFn()}>
            <span>
              <LogoutOutlined className="mr-3" />
              <span className="font-weight-normal">Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item>
          <Avatar src={profileImg} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}

export default connect(null)(NavProfile)
